import { cn } from "@/lib/utils";
import { Thumbnail, ThumbnailFallback, ThumbnailImage, Typography } from "@backpac/monica";

interface ProfileProps {
  name: string;
  description?: string;
  profileImageUrl?: string;
  className?: string;
  fallbackClassName?: string;
  size?: "sm" | "md" | "lg";
}

export function Profile({
  name,
  description,
  profileImageUrl,
  className,
  fallbackClassName,
  size = "lg",
}: ProfileProps) {
  const thumbnailSize = size === "sm" ? "size-8" : size === "md" ? "size-10" : "size-12";

  return (
    <div className={cn("flex items-center gap-3", className)}>
      <Thumbnail className={thumbnailSize}>
        <ThumbnailImage src={profileImageUrl} alt={`${name} profile image`} />
        <ThumbnailFallback className={fallbackClassName}>{name.slice(0, 1).toUpperCase()}</ThumbnailFallback>
      </Thumbnail>
      <div className="flex flex-col gap-1 items-start">
        <Typography size="xs" color="textPrimary" weight={600}>
          {name}
        </Typography>
        {description != null ? (
          <Typography size="xs" color="textMuted" className="text-left">
            {description}
          </Typography>
        ) : null}
      </div>
    </div>
  );
}
